import { render, staticRenderFns } from "./CardInput.vue?vue&type=template&id=fac22d1e&"
import script from "./CardInput.vue?vue&type=script&lang=js&"
export * from "./CardInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports